exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-container[data-v-5101c692]{margin-right:30px}.avatar-container .avatar-wrapper[data-v-5101c692]{margin-top:5px;position:relative}.avatar-container .avatar-wrapper .user-avatar[data-v-5101c692]{cursor:pointer;width:40px;height:40px;border-radius:50%}.avatar-container .avatar-wrapper .el-icon-caret-bottom[data-v-5101c692]{cursor:pointer;position:absolute;right:-20px;top:25px;font-size:12px}\n", ""]);

// exports
